export const AssessmentNextActionEnum = Object.freeze({


      ModuleCompleted : 0,  // Passed & module is finished
      CourseCompletedWithCertificate : 1, // Passed & course is finished with certificate
      RetryAllowed : 2,     // Failed but a retry is allowed
      ModuleRecycled : 3,    // Failed final attempt → module reset,
      FailedNoMoreAttempts : 4,// Failed second cycle's final attempt → no more attempts allowed he needs mentor to course training again. course block

      // NEW CASES where Asseessment cannot be taken
      ModuleAlreadyCompleted : 5,
      AlreadyPassed : 6,
      BlockedNoAttemptsLeft :7,
      CourseAlreadyCompleted : 8

  

})

  